"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationProvider = void 0;
var react_1 = __importStar(require("react"));
var Pagination_scss_1 = __importDefault(require("./Pagination.scss"));
var react_responsive_pagination_1 = __importDefault(require("react-responsive-pagination"));
var PaginationProvider = function (props) {
    var total = Math.ceil(props.rowsPerPage > 0 ? Math.abs(props.totalRows / props.rowsPerPage) : 0);
    var _a = (0, react_1.useState)(0), currentPage = _a[0], setCurrentPage = _a[1];
    var handlePageChange = function (p) {
        props.onChange && props.onChange((p - 1) * props.rowsPerPage);
        setCurrentPage(p);
    };
    return (react_1.default.createElement(react_responsive_pagination_1.default, { total: total, current: currentPage, onPageChange: function (p) { return handlePageChange(p); }, previousLabel: "Back", nextLabel: "Next", extraClassName: "".concat(Pagination_scss_1.default['acma-pagination']), activeItemClassName: "active ".concat(Pagination_scss_1.default['acma-pagination-active']) }));
};
exports.PaginationProvider = PaginationProvider;
//# sourceMappingURL=Pagination.js.map